import { dataInvoiceSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconInvoiceSolid = /*#__PURE__*/createIcon(dataInvoiceSolid)
export default IconInvoiceSolid
